/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDentalSurfaces } from 'app/entities/dental-surface/dental-surface.reducer';
import { getEntities as getDentalMouthItems } from 'app/entities/dental-mouth-item/dental-mouth-item.reducer';
import { ErotionType } from 'app/shared/model/enumerations/erotion-type.model';
import { createEntity, getEntity, reset, updateEntity } from './dental-surface-erosion.reducer';

export const DentalSurfaceErosionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dentalSurfaces = useAppSelector(state => state.dentalSurface.entities);
  const dentalMouthItems = useAppSelector(state => state.dentalMouthItem.entities);
  const dentalSurfaceErosionEntity = useAppSelector(state => state.dentalSurfaceErosion.entity);
  const loading = useAppSelector(state => state.dentalSurfaceErosion.loading);
  const updating = useAppSelector(state => state.dentalSurfaceErosion.updating);
  const updateSuccess = useAppSelector(state => state.dentalSurfaceErosion.updateSuccess);
  const erotionTypeValues = Object.keys(ErotionType);

  const handleClose = () => {
    navigate(`/dental-surface-erosion${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDentalSurfaces({}));
    dispatch(getDentalMouthItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.score !== undefined && typeof values.score !== 'number') {
      values.score = Number(values.score);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...dentalSurfaceErosionEntity,
      ...values,
      surface: dentalSurfaces.find(it => it.id.toString() === values.surface?.toString()),
      mouthItem: dentalMouthItems.find(it => it.id.toString() === values.mouthItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          erotionType: 'ATTRITION',
          ...dentalSurfaceErosionEntity,
          surface: dentalSurfaceErosionEntity?.surface?.id,
          mouthItem: dentalSurfaceErosionEntity?.mouthItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dentalSurfaceErosion.home.createOrEditLabel" data-cy="DentalSurfaceErosionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dentalSurfaceErosion.home.createOrEditLabel">
              Create or edit a DentalSurfaceErosion
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dental-surface-erosion-id"
                  label={translate('tinyMedicRestApp.dentalSurfaceErosion.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.erotionType')}
                id="dental-surface-erosion-erotionType"
                name="erotionType"
                data-cy="erotionType"
                type="select"
              >
                {erotionTypeValues.map(erotionType => (
                  <option value={erotionType} key={erotionType}>
                    {translate(`tinyMedicRestApp.ErotionType.${erotionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.score')}
                id="dental-surface-erosion-score"
                name="score"
                data-cy="score"
                type="text"
                validate={{
                  min: { value: 0, message: translate('entity.validation.min', { min: 0 }) },
                  max: { value: 4, message: translate('entity.validation.max', { max: 4 }) },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.active')}
                id="dental-surface-erosion-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.cursor')}
                id="dental-surface-erosion-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.lastupdated')}
                id="dental-surface-erosion-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.microSec')}
                id="dental-surface-erosion-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.timestampentry')}
                id="dental-surface-erosion-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="dental-surface-erosion-surface"
                name="surface"
                data-cy="surface"
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.surface')}
                type="select"
              >
                <option value="" key="0" />
                {dentalSurfaces
                  ? dentalSurfaces.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="dental-surface-erosion-mouthItem"
                name="mouthItem"
                data-cy="mouthItem"
                label={translate('tinyMedicRestApp.dentalSurfaceErosion.mouthItem')}
                type="select"
              >
                <option value="" key="0" />
                {dentalMouthItems
                  ? dentalMouthItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dental-surface-erosion" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DentalSurfaceErosionUpdate;
